import type { IGamesInfo } from '@/store/commonStore/types';

export const EMPTY_GAMES_INFO: IGamesInfo = {
  isFailed: true,
  games: [],
  pagination: {
    totalCount: 0,
    currentPage: 1,
    nextPage: 0,
    prevPage: null,
    totalPages: 0,
  },
};
